import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DtcQuery } from '../../../../../shared/models/dtc/dtc-query';
import { FormsModule } from '@angular/forms';
import { pascalCaseToWords } from '../../../../common/common-utils';
import { CloseIconComponent } from '../../../icons/close-icon/close-icon.component';
import { BaseFilter } from '../../../base/base-filter';
import { AgentActionDirective } from '../../../../directives/agent-action.directive';
import { ThreeStateToggleComponent } from '../../../common/three-state-toggle/three-state-toggle.component';

@Component({
  selector: 'app-dtc-filter',
  imports: [FormsModule, CloseIconComponent, AgentActionDirective, ThreeStateToggleComponent],
  templateUrl: './dtc-filter.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './dtc-filter.component.scss',
})
export class DtcFilterComponent extends BaseFilter<DtcQuery> implements OnInit {
  @Input() public recyclingModeEnabled = false;

  public pascalCaseToWords = pascalCaseToWords;

  constructor() {
    const defaultFilter: DtcQuery = {
      searchInOtherFields: true,
      searchInValue: true,
    };
    super(420, defaultFilter);
  }

  public override ngOnInit(): void {
    super.ngOnInit();
    this.searchQuery.searchInValue = this.defaultFilter.searchInValue;
    this.searchQuery.searchInOtherFields = this.defaultFilter.searchInOtherFields;
  }
}
